var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCyLearningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graduation-cap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 10.5352V17.6185C10.75 21.8685 19.25 21.8685 23.5 17.6185V10.5352",
    fill: "url(#paint0_linear_236_1295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.41365 9.49133C2.93955 8.75428 2.93955 6.65067 4.41365 5.91362L14.1082 1.06635C14.6712 0.784827 15.334 0.784827 15.897 1.06635L25.5916 5.91362C27.0657 6.65067 27.0657 8.75428 25.5916 9.49133L15.897 14.3386C15.334 14.6201 14.6712 14.6201 14.1082 14.3386L4.41365 9.49133Z",
    fill: "#181A49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_236_1295",
    x1: 17.8003,
    y1: 16.9307,
    x2: 2.27443,
    y2: 18.6506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDDFC",
    stopOpacity: 0.28
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyLearningIcon);
export default __webpack_public_path__ + "static/media/cy-learning-icon.6893afd556ac5a56b605b6b9b87a5c0a.svg";
export { ForwardRef as ReactComponent };